var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tokenre-container"},[(!_vm.tokenQuery)?_c('h3',[_vm._v(" Token bulunamadı, pencereyi kapatabilirsin.")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }